import React, { useState } from 'react';
import Pagination from 'components/atoms/pagination';

interface ItemProps {
  item: any;
}

const ListItemIminencia = (props: ItemProps) => {
  const { item } = props;
  const [currentPage, setCurrentPage] = useState<number>(1);

  const indexOfLastPost = currentPage * 15;
  const indexOfFirstPost = indexOfLastPost - 15;

  const currentPosts = item?.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  return (
    <>
      <p className="mb-1 mt-3 font-weight-bold">Itens com iminência de deserta</p>
      <div className="card mb-3">
        <div className="card-body p-0">
          <table className="table table-responsive mb-0">
            <thead className="thead-light">
              <tr>
                <th className="align-middle text-center" scope="col">
                  Item
                </th>
                <th className="align-middle w-100" scope="col">
                  Descrição
                </th>
                <th className="align-middle text-center" scope="col">
                  Qnt.
                </th>
                <th className="align-middle text-center" scope="col">
                  Valor Estimado
                </th>
                <th className="align-middle" scope="col">
                  Situação
                </th>
              </tr>
            </thead>
            <tbody>
              {currentPosts?.map((item: any) => (
                <tr>
                  <td className="font-weight-bold text-center">{item?.number_item}</td>
                  <td>{item?.description_item}</td>
                  <td className="text-center">{item?.quantity}</td>
                  <td className="text-center">
                    {Number(item?.estimated_value).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </td>
                  <td>{item?.bidding_desert_imminence_situation}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row d-print-none mx-0 border-top">
            <div className="col-md-12 p-2">
              <Pagination
                postsPerPage={15}
                totalPosts={item?.length}
                paginate={paginate}
                currentPage={currentPage}
                firstAndLastPage
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListItemIminencia;
